import React from 'react';
import styles from '../irlObservations2026.module.css';
import { FreshnessBadge } from '../chrome';
import { stripHtmlText } from './shared';

export default function Obs_Review_IRL({ items, obsCount, tab, onTab, onBack, onOpenIrl, onAnalyse, onDismiss, busy }) {
    const rows = items || [];
    return (
        <>
            <div className={styles.suggestHead}>
                <div>
                    <button type="button" className={styles.backBtn} onClick={onBack}>
                        ← Observations
                    </button>
                    <h2 className={styles.suggestKicker}>Review affected items</h2>
                    <p className={styles.suggestMeta}>
                        {rows.length + (obsCount || 0)} items may need review · New evidence has become Ready since these records were last reviewed.
                    </p>
                </div>
            </div>
            <div className={styles.tabs}>
                <button type="button" className={`${styles.tab} ${tab === 'IRL Responses' ? styles.tabActive : ''}`} onClick={() => onTab('IRL Responses')}>
                    IRL Responses
                    <span className={styles.tabMutedCount}>{rows.length}</span>
                </button>
                <button type="button" className={`${styles.tab} ${tab === 'Observations' ? styles.tabActive : ''}`} onClick={() => onTab('Observations')}>
                    Observations
                    <span className={styles.tabMutedCount}>{obsCount || 0}</span>
                </button>
            </div>
            <div className={styles.detailBody}>
                {rows.length === 0 && <p className={styles.emptyBody}>No affected IRL responses to review.</p>}
                {rows.map(item => (
                    <div key={item.id} className={styles.reviewCard}>
                        <div className={styles.suggestTitleRow}>
                            <div>
                                <div className={styles.suggestId}>{item.id}</div>
                                <div className={styles.rowTitle}>{stripHtmlText(item.title)}</div>
                            </div>
                            <FreshnessBadge value={item.freshness} />
                        </div>
                        <div className={styles.sectionLabelSm}>What changed</div>
                        <p className={styles.responseBody}>{item.whatChanged}</p>
                        <div className={styles.actionRow}>
                            <button type="button" className={styles.outlineBtn} onClick={() => onOpenIrl(item.id)}>
                                Open IRL
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}
